import { type ApiEnvelope, api, unwrap } from "@/lib/api";
import type { AuthUser, MfaMethod } from "@/stores/auth.store";

export interface LoginResponse {
	status: "needs-2fa" | "authenticated";
	pendingToken?: string;
	methods?: MfaMethod[];
	accessToken?: string;
	refreshToken?: string;
	user?: AuthUser;
}

export const authApi = {
	login: (email: string, password: string) =>
		unwrap<LoginResponse>(
			api.post<ApiEnvelope<LoginResponse>>("/auth/login", { email, password }),
		),

	verify2fa: (pendingToken: string, code: string) =>
		unwrap<LoginResponse>(
			api.post<ApiEnvelope<LoginResponse>>("/auth/login/2fa", {
				pendingToken,
				code,
			}),
		),

	me: () => unwrap<AuthUser>(api.get<ApiEnvelope<AuthUser>>("/auth/me")),

	logout: (refreshToken: string) =>
		unwrap<void>(api.post<ApiEnvelope<void>>("/auth/logout", { refreshToken })),

	forgotPassword: (email: string) =>
		unwrap<{ ok: true }>(
			api.post<ApiEnvelope<{ ok: true }>>("/auth/forgot-password", { email }),
		),

	resetPassword: (token: string, password: string) =>
		unwrap<{ ok: true }>(
			api.post<ApiEnvelope<{ ok: true }>>("/auth/reset-password", {
				token,
				password,
			}),
		),
};
